import {DTNode, DTSocialCreativeNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {ServerNode} from 'common/src/modules/nodes/nodes.types';
import {serializeCreativeNode} from 'common/src/modules/campaignVersions/utils/serializeConceptCreativeNode';

export function serializeFacebookCreativeNode(node: DTNode, newNode: ServerNode) {
  const creativeNode = node as DTSocialCreativeNode;

  return {
    ...serializeCreativeNode(node, newNode),
    type: creativeNode.type,
    externalAdPrimaryText: creativeNode.externalAdPrimaryText || [],
    externalAdHeadline: creativeNode.externalAdHeadline || [],
    externalAdLongHeadline: creativeNode.externalAdLongHeadline || [],
    externalAdDescription: creativeNode.externalAdDescription || [],
    externalAdCTA: creativeNode.externalAdCTA,
    displayUrl: creativeNode.displayUrl,
    identity: creativeNode.identity,
    additionalIdentity: creativeNode.additionalIdentity,
    trackingPixel: creativeNode.trackingPixel,
    adNameTemplate: creativeNode.adNameTemplate || null,
    mediaNameTemplate: creativeNode.mediaNameTemplate || null,
    adType: creativeNode.adType,
    trackingPixels: creativeNode.trackingPixels,
  };
}
